export default __webpack_public_path__ + "static/media/upi-not-found.63b9bb98.svg";